import React from "react";

export const FormSent = ({ thankYou }) => {
  return <h3 className="h3 conf-form__message">{thankYou}</h3>;
};
